//@ts-nocheck
import React from 'react';
import { Table, Form, Badge } from 'react-bootstrap';
import styled from 'styled-components';

const StyledTable = styled(Table)`
  th {
    background-color: #f8f9fa;
    border-top: none;
    font-weight: 600;
  }

  .quantity-input {
    width: 120px;
    text-align: center;
    font-size: 1.1rem;
    font-weight: 600;
    padding: 8px 12px;
    margin: 0 auto;
    border: 2px solid #dee2e6;
    border-radius: 6px;

    &:focus {
      border-color: #28a745;
      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
    }
  }

  .price-column {
    text-align: right;
    font-weight: 600;
  }

  .total-price {
    color: #28a745;
    font-weight: bold;
  }
`;

const StatusBadge = styled(Badge)`
  font-size: 0.8em;
`;

const ProductsTable = ({ products, orderItems, onQuantityChange }) => {
  // Debug: sprawdźmy co otrzymujemy
  console.log('ProductsTable received orderItems:', orderItems);

  const getQuantityStatus = (quantity, minQuantity) => {
    if (quantity === 0) {
      return { text: 'Brak', variant: 'danger' };
    } else if (quantity <= minQuantity) {
      return { text: 'Niski stan', variant: 'warning' };
    } else {
      return { text: 'Dostępny', variant: 'success' };
    }
  };

  const calculateSuggestedQuantity = (product) => {
    const currentQuantity = product.quantity || 0;
    const desiredQuantity = product.desiredQuantity || 0;
    const suggested = Math.max(0, desiredQuantity - currentQuantity);
    return suggested;
  };

  const calculateItemTotal = (product, orderQuantity) => {
    if (!orderQuantity || orderQuantity <= 0) return 0;
    return product.price * parseInt(orderQuantity, 10);
  };

  return (
    <div className="mb-4">
      <h6 className="mb-3">Dostępne produkty</h6>
      <StyledTable responsive striped bordered hover size="sm">
        <thead>
          <tr>
            <th>Typ</th>
            <th>Nazwa</th>
            <th>Cena (PLN)</th>
            <th>Min. ilość</th>
            <th>Aktualny stan</th>
            <th>Pożądana ilość</th>
            <th>Status</th>
            <th>Ilość do zamówienia</th>
            <th className="price-column">Wartość (PLN)</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => {
            const suggestedQuantity = calculateSuggestedQuantity(product);
            // Użyj wartości z orderItems (już ustawionej przez rodzica) lub pustej jeśli nie ma
            const orderQuantity =
              orderItems[product._id] !== undefined
                ? orderItems[product._id]
                : '';
            const itemTotal = calculateItemTotal(product, orderQuantity);
            const status = getQuantityStatus(
              product.quantity,
              product.minQuantity,
            );

            return (
              <tr key={product._id}>
                <td>
                  <Badge bg="secondary">{product.type}</Badge>
                </td>
                <td>
                  <strong>{product.name}</strong>
                </td>
                <td className="price-column">
                  {product.price?.toFixed(2) || '0.00'}
                </td>
                <td className="text-center">{product.minQuantity || 0}</td>
                <td className="text-center">
                  <strong
                    className={
                      product.quantity === 0
                        ? 'text-danger'
                        : product.quantity <= product.minQuantity
                        ? 'text-warning'
                        : 'text-success'
                    }
                  >
                    {product.quantity || 0}
                  </strong>
                </td>
                <td className="text-center">
                  <strong className="text-info">
                    {product.desiredQuantity || 0}
                  </strong>
                </td>
                <td>
                  <StatusBadge bg={status.variant}>
                    {status.text}
                  </StatusBadge>
                </td>
                <td className="text-center">
                  <Form.Control
                    type="number"
                    min="0"
                    step="1"
                    value={orderQuantity}
                    onChange={(e) =>
                      onQuantityChange(product._id, e.target.value)
                    }
                    className="quantity-input"
                    placeholder={
                      suggestedQuantity > 0
                        ? `Sugerowane: ${suggestedQuantity}`
                        : '0'
                    }
                  />
                </td>
                <td className="price-column">
                  <span className={itemTotal > 0 ? 'total-price' : ''}>
                    {itemTotal.toFixed(2)}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </StyledTable>
    </div>
  );
};

export default ProductsTable;
